import React from 'react';
import './PromocodeIcon.less';

import CheckIcon from 'new-images/check.svg';

export const PromocodeIcon = () => {
	return <span className="promocode-icon" dangerouslySetInnerHTML={{__html: CheckIcon}}></span>;
};
